import API, { handleRequest } from '@/api/lib/api'

export const sendGiftCardMail = (id, data, config = {}) =>
  handleRequest(() => API.post(`restaurant/gift-cards/${id}/send`, data, config))

export const printGiftCard = (restaurant_id, id, payload = {}) =>
  handleRequest(() =>
    API.post(`restaurant/${restaurant_id}/loyalty/${id}/print`, {
      restaurant_id: Number(restaurant_id),
      card_type: 'gift-card',
      ...payload,
    })
  )

export const printLoyaltyCard = (restaurant_id, id, card_type, payload = {}) =>
  handleRequest(() =>
    API.post(`restaurant/${restaurant_id}/loyalty/${id}/print`, {
      restaurant_id: Number(restaurant_id),
      card_type: typeof card_type === 'string' ? card_type : 'gift-card',
      ...(typeof card_type === 'object' ? card_type : {}),
      ...payload,
    })
  )
